import script from "./HostsGuestsView.vue?vue&type=script&setup=true&lang=js"
export * from "./HostsGuestsView.vue?vue&type=script&setup=true&lang=js"

import "./HostsGuestsView.vue?vue&type=style&index=0&id=a0dbcf42&lang=scss"

const __exports__ = script;

export default __exports__